import api from './api';

const userService = {
  // Get all users with pagination
  getUsers: async (page = 1, limit = 10) => {
    return api.get(
      `/users?page=${page}&limit=${limit}`
    );
  },

  // Alias for backward compatibility
  getAllUsers: async (page = 1, limit = 10) => {
    return api.get(`/users?page=${page}&limit=${limit}`);
  },

  // Get a user by ID
  getUser: async (id) => {
    return api.get(`/users/${id}`);
  },

  // Alias for getUser
  getUserById: async (id) => {
    return api.get(`/users/${id}`);
  },

  // Create a new user
  createUser: async (userData) => {
    return api.post(`/users`, userData);
  },

  // Update a user
  updateUser: async (id, userData) => {
    return api.put(`/users/${id}`, userData);
  },

  // Delete a user
  deleteUser: async (id) => {
    return api.delete(`/users/${id}`);
  },

  // Change user password
  changeUserPassword: async (id, passwordData) => {
    return api.put(`/users/${id}/password`, passwordData);
  },
};

export default userService;
